import { useEffect, useState, useCallback, useContext } from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import Rating from '@mui/material/Rating'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Link from 'next/link'
import * as config from '../../../next.config.js'
import LocalPhoneOutlineIcon from '@mui/icons-material/Phone'

import { useRouter } from "next/router";
import axios from "axios";
import { constants } from "../../../constants";
import { isOpenOrClose } from '../../helpers/global/datesTimes/datesTimesFunctions'
import SeeMore from '../SeeMore'
import { getTermsByVocabCode } from '../../helpers/global/term/term'
import styled from '@mui/system/styled'
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import { useCart } from "../../../context/cart/use-cart";
import PropTypes from "prop-types";
import { getCookieValue, encryption } from '../../helpers/helpers'
import Loading from "../../../components/components/Loaders/Loading";
import Cookie from 'js-cookie'
import TermsContext from "../../../context/Trems"
import { ManipulateSearchOfArabicLetters } from "../../helpers/ManipulateSearchOfArabicLetters"
import { getImage } from '../../helpers/images'
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { CustomeCheckbox } from "../Blog/Blog.style"
import NoData from '../../../components/components/NoData'
import PersonOutlineOutlinedIcon from '@mui/icons-material/Person'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(0)

    },
    "& .MuiDialogAction-root": {
        padding: theme.spacing(0)
    },

    "& .MuiDialog-paper": {
        maxWidth: "900px !important ",
        direction: "ltr",
        display: "grid",
        justifyContent: "center",
        height: "310px",
        width: "350px",



        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
        },

        "& .MuiSelect-icon": {
            color: "teal"
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: 0,
            borderColor: "white"
        },
        "& .MuiInputLabel-root": {
            fontSize: "1.2rem"

        }
    }
}));
const Imgsdialog = props => {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle
            sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between" }}
            {...other}
            className={style.DialogTitle}
        >
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: "90%",
                        left: "80%",
                        top: 23,
                        marginBottom: 0,
                        color: "teal",
                        "@media (min-width:600px)": {
                            left: "90%"
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
Imgsdialog.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
};

function NearestEntities(props) {
    const { locale } = useRouter();

    const [showslider, setshowslider] = useState(props.showSlider)
    const vocabTerms = useContext(TermsContext)
    const { t } = useTranslation("common")
    const [value, setValue] = useState(2)
    const [pageId, setPageId] = useState(1)
    const [lstMedicalData, setLstMedicalData] = useState([])
    const [lstMedicalDataMajors, setLstMedicalDataMajors] = useState([])

    const [lstMedicalDataWorkTimes, setLstMedicalDataWorkTimes] = useState([])
    const [loading, setLoading] = useState(true)
    const [showSeeMore, setShowSeeMore] = useState(false)
    const router = useRouter()
    const [offerPriceEntityDetails,setOfferPriceEntityDetails]=useState([])
    const [shippingOffers,setShippingOffers]=useState([])
    const limit = 10

    const callbackData = useCallback(callback => callback, []);
    async function getData(pageNumber) {
        let statusLst = props.status

        if (typeof statusLst == 'string') {
            statusLst = JSON.parse(props.status)
        }
        setLoading(true)
        let data = {
            lang: locale,
            statusId: JSON.stringify(statusLst),
            active: 1,
            limit: limit,
            pageId: pageNumber,
            latitude: props.currentLocation&&props.currentLocation.lat,
            longitude: props.currentLocation&&props.currentLocation.lng,
        }
        if (props.entityTypeId) {

            data["entityTypeId"] = JSON.stringify(props.entityTypeId)
            data.requiredEntityTypeId = 'true'
        }
        else {
            let entityCategories = await getTermsByVocabCode("entity-categories")
            if (router.query.entityType) {
                entityCategories = JSON.parse(entityCategories).filter(ele => ele.field3 != null && JSON.parse(ele.field3) && JSON.parse(ele.field3).displayInSearch == "true" && router.query.entityType.includes(ele.code))
                entityCategories = entityCategories.filter(ele => ele.field3 != null && JSON.parse(ele.field3) && JSON.parse(ele.field3).displayInSearch == "true" && router.query.entityType.includes(ele.code))
                let entityTypes = vocabTerms.entityTypes.filter(ele => router.query.entityType.includes(ele.code) && entityCategories.map(r => r.code).includes(ele.code) == false)
                let tempEntityTypes = []
                if (entityTypes.length > 0) {
                    tempEntityTypes.push(...router.query.entityType.split(","))
                }
                if(router.query.isFood){
                if (entityCategories.length > 0) {
                    tempEntityTypes.push(...vocabTerms.entityTypes.filter(ele => ele.code == "merchant").map(ele => ele.code))
               
                    data.entityCategoriesId = JSON.stringify(entityCategories.map(ele => ele.id))
                    data.entityTypeIdByEntityCategories = JSON.stringify(vocabTerms.entityTypes.filter(ele => ele.code == "merchant").map(ele => ele.code))
                }
            }
                if (tempEntityTypes.length > 0) {
                    data["entityTypeId"] = JSON.stringify(tempEntityTypes)
                    data.requiredEntityTypeId = 'true'
                }
            }
            else {
                entityCategories = JSON.parse(entityCategories).filter(ele => ele.field3 != null && JSON.parse(ele.field3) && JSON.parse(ele.field3).displayInSearch == "true")
                data["entityTypeId"] = JSON.stringify(vocabTerms.entityTypes.filter(
                    x =>
                        x.code == "merchant" || (x.field3 == 1 &&
                            vocabTerms.statusIds.includes(x.statusId) &&
                            x.language.code == router.locale)
                ).map(ele => ele.code))
                data.requiredEntityTypeId = 'true'
             
                // console.log("isMEdica========>")
                if(router.query.isFood){
                    data.entityTypeIdByEntityCategories = JSON.stringify(vocabTerms.entityTypes.filter(
                        x =>
                            x.code == "merchant" || (
                                vocabTerms.statusIds.includes(x.statusId) &&
                                x.language.code == router.locale)
                    ).map(ele => ele.code))
                    data.entityCategoriesId = JSON.stringify(entityCategories.map(ele => ele.id))

                }
            }
        }
        if (router.query.city) {
            data["city"] = router.query.city
            data.limit = 50
        }
        if (router.query.district) {
            data["districtId"] = router.query.district
            data.limit = 50
        }
        if (router.query.entityName) {
            let ManipulateSearch = ManipulateSearchOfArabicLetters("officialName", "CONTAINS", router.query.entityName, "transEntityDetails")
            data["officialName"] = JSON.stringify(ManipulateSearch);
            data.limit = 10
        }
        let status = props.statusIds
        if (typeof status == 'string') {
            status = JSON.parse(props.statusIds)
        }
        data.statusId = JSON.stringify(status)
        if (props.entityId) {
            data["entityId"] = JSON.stringify(props.entityId)
        }
        if (props.parentId) {
            data["parentId"] = JSON.stringify(props.parentId)
        }
        if (getCookieValue("userCountry")) {
            data["userCountryCode"] = getCookieValue("userCountry")
        }
        axios.post(`${config['basePath']}/api/registeration/reports/nearestDistance/get`,
            {
                data: data
            }).then(async (entities) => {
                let tempOffers=[]
                if (entities.data.data&&entities.data.data.content.length > 0) {
                    callbackData(entities.data.data.content)
                    let tempData = entities.data.data.content
                    if (router.query.district&& router.query.city) {
                        let districts = await getTermsByVocabCode("districts")
                        let districtId = JSON.parse(districts).filter(i => i.name == router.query.district)[0].id
                        tempData=tempData.filter(ele=>ele.addressDetails.map(d=>d.districtId).includes(districtId))
                    }
                
                    if (router.query.city && !router.query.district) {
                        let cities = await getTermsByVocabCode("cities")
                        let cityId = cities&&JSON.parse(cities).filter(i => i.name == router.query.city)[0].code
                        let districts = await getTermsByVocabCode("districts")
                        districts = JSON.parse(districts).filter(ele => ele.field1 == cityId)
                        if (districts.length > 0) {
                            const districtsForCity = districts.map(a => a.id);
                          
                            tempData=tempData.filter(ele=>districtsForCity.includes(ele.addressDetails[0].districtId))
                     
                       
                        }
                    }
                    tempData.map(x => {
                        x.entityImages.map(ele => {
                            if (ele.files) {
                                let fileString = ele.files.filePath
                                let rest = fileString.substring(0, fileString.lastIndexOf("/") + 1)
                                let last = fileString.substring(fileString.lastIndexOf("/") + 1, fileString.length)
                                let fileThumbnai = (rest + "thumbnail250/" + last)
                                getImage(ele.fileId, fileThumbnai).then(res => {
                                    if (res != "") {
                                        ele.image = res
                                    }

                                })
                            }
                            return ele
                        })
                        return x
                    })
                   
                    data["entityId"] = JSON.stringify(entities.data.data.content.map(ele => ele.id))
                    axios.post(`${config['basePath']}/api/products/reports/reportProductOrderOfferTopPrice/get`,
                    {
                        data: data
                    }).then(async (entities2) => {
                      setOfferPriceEntityDetails(entities2.data.data.filter(x=>x.active))
                      tempData.map(e=>{
                        if(entities2.data.data.filter(x=>x.id==e.id).length>0){
                            e.offers=entities2.data.data.filter(x=>x.id==e.id&&x.active&&x.percentage>0)
                            return e
                        }
                      })
                      tempData=tempData.map(ele=>{
                        if(ele.offers&&ele.offers.length>0){
                            ele.offers[0].offers.map(x=>{
                                if(x.percentage==0){
                                    x.percentage=1
                                }
                            })
                        }
                        return ele
                    })
                     tempOffers=tempData.filter(ele=>ele.offers)
                    tempOffers=tempOffers.sort((c,d)=>{
                        if(c.offers&&d.offers){
                        if(c.offers.length>0&&c.offers[0].offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage).length>0&& d.offers.length>0&&d.offers[0].offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage).length>0){
                           if(c.offers[0].offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage)[0].percentage<=d.offers[0].offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage)[0].percentage){
                                       return 1
                                   }
                                   else{
                                       return -1
                                   }
                       }
                       else{
                           return -1
                       }
                    }
                   })

                    
                    }).catch(err=>console.log("err=========>",err))
                    await  axios.post(`${config['basePath']}/api/shipping/shippingOffers/get`,
                    {
                        data: {...data,entityId:JSON.stringify(tempData.map(a=>a.id))}
                    }).then((shippingOffer) => {
                        if(shippingOffer.data.data.content.length>0){
                        let shippingOffersLst= shippingOffer.data.data.content
                        setShippingOffers(shippingOffersLst)
                        // tempData.map(a=>{
                        //    a.shippingOfferEntityDetails=shippingOffers.filter(s=>s.id==a.id && s.active==true).length>0?shippingOffers.filter(s=>s.id==a.id && s.active==true)[0].offers:[]
                        //    return a
                        // })
                        }
                    }).catch((err) => {})
                   // majors
                   if (pageNumber > 1) {
                    setLstMedicalData(prev => [...prev, ...tempData])
                }
                else {
                    setLstMedicalData([...tempData])
                }
                setLoading(false)
          await axios.get(`${config['basePath']}/${constants.ENTITY_MAJORS_URL}`,
          {
            params: {
              entityId: data.entityId,
              statusId: status,
            }
          }).then((entitiesMajors) => {

            let tempMajorData = entitiesMajors.data.data.data

            tempMajorData = tempMajorData.map(majorItem => {
              majorItem["titles"] = majorItem["titles"].filter(title => title.language.code == locale)
              majorItem["major"] = majorItem["major"].filter(major => major.language.code == locale)
              majorItem["subMajor"] = majorItem["subMajor"].filter(subMajor => subMajor.language.code == locale)
              return majorItem
            })

            entities.data.data.data.map(ele => {
              ele.majors = tempMajorData.filter(x => x.entityDetailsId == ele.id)
              return ele
            })

            setLstMedicalDataMajors(prev => [...prev, ...tempMajorData])
          }).catch(err => err)
                    await axios.get(`${config['basePath']}/${constants.ENTITY_WORK_TIME_URL}`,
                        {
                            params: {
                                entityId: data.entityId,
                                statusId: JSON.stringify(status)
                            }
                        }).then((entitiesWorkTimes) => {
                            let tempWorkTimesData = entitiesWorkTimes.data.data.data
                            setLstMedicalDataWorkTimes(prev => [...prev, ...tempWorkTimesData])
                            entities.data.data.data.map(ele => {
                                ele.workTime = tempWorkTimesData.filter(x => x.id == ele.id)
                                return ele
                            })
                        }).catch(err => err)
                }
                else {
                    setLstMedicalData([])
                    setShowSeeMore(false)
                    setLoading(false)
                }
                
            
            }).catch((err) => console.log("err===========>", err))

    }

    const { addItem, removeItem, getItem } = useCart();

    useEffect(() => {
        if (getCookieValue("userCountry")) {
            setLstMedicalData([])
        }
        getData(1)
    }, [props.entityId, props.parentId, router.query, getCookieValue("userCountry"), props.currentLocation])
    const getMore = () => {
        setPageId(pageId + 1)
        let pageNumber = pageId + 1
        getData(pageNumber)
    }
    const handleAddSponsor = (e, item) => {
        if (item.sponsor == true) {
            Cookie.set(encryption("sponsor"), encryption(constants.sponsorUrl))
        } else {
            Cookie.set(encryption("sponsor"), encryption(constants.freeUrl))
        }
    }

    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>

            <div className={lstMedicalData.length > 0 && props.isInSearchPage ? style.SectionContainer : ""} style={{ padding: 0 }}>
                {/* {console.log("lstMedicalData=========>",lstMedicalData.sort((a,b)=>a.offers.length>0||b.offers.length>0?-1:1))} */}
                {
                    lstMedicalData.length > 0 &&
                    lstMedicalData.map((item, index) => {
                        return (
                            <div className={style.allcard3 + " mb-2 h-[170px] md:h-[240px]"} key={index}>
                                <span className={style.AtagIcon + " h-full"}>
                                    <div className={style.stylesSection7 + " " + style.sizeCard + " h-full"}>
                                        <div className={"absolute left-0"}>
                                            <div >
                                                <img src={`${config.basePath}/assest/Myfav.svg`}
                                                    alt={"hakeem"}
                                                    className='w-9'
                                                ></img>
                                                <div className='absolute left-0 right-0 top-0'>
                                                <CustomeCheckbox
                                                    label={"start"}

                                                    checkedIcon={
                                                        <img
                                                            className='w-6'
                                                            // className={style.StarDiet + " " + style.heartdetails}
                                                            src={`${config.basePath}/assest/Fullstar.svg`}
                                                            alt={"hakeem"}
                                                        ></img>
                                                    }
                                                    checked={getItem(item.id, null, item.id, getCookieValue("userCountry")) != null && getItem(item.id, null, item.id, getCookieValue("userCountry")).isFavoriate == true}
                                                    icon={<img
                                                        // className={style.StarBorderDiet + " " + style.heartdetails}
                                                        className='w-6'
                                                        alt={"hakeem"}
                                                        src={`${config.basePath}/assest/OutlineStar.svg`}
                                                    ></img>}

                                                    // className={style.heart}
                                                    value={getItem(item.id, null, item.id) != null && getItem(item.id, null, item.id).isFavoriate == true}
                                                    onClick={(e) => {
                                                        if (e.target.checked == true) {

                                                            addItem({
                                                                type: "entities",
                                                                //subType:"entities",
                                                                entityId: item.id,
                                                                isFavoriate: true,
                                                                quantity: 0,
                                                                productUnitPrice: null,
                                                                entityDetailsId: item.id,
                                                                userCountry: getCookieValue("userCountry")

                                                            })
                                                        } else if (e.target.checked == false) {
                                                            removeItem({
                                                                type: "entities",
                                                                //subType:"entities",
                                                                entityId: item.id,
                                                                isFavoriate: false,
                                                                quantity: 0,
                                                                productUnitPrice: null,
                                                                entityDetailsId: item.id,
                                                                userCountry: getCookieValue("userCountry")
                                                            })
                                                        }
                                                    }}

                                                />
                                                </div>
                                            </div>
                                        
                                        </div>
                                        <div  className='grid md:flex justify-end absolute left-12 md: left-10  '>
                                     { item.offers &&item.offers.length > 0 && item.offers.filter(ele => ele.percentage > 1).sort((a, b) => a.percentage > b.percentage).length > 0 ? <div className=' p-1 bg-[#F52A59] text-white rounded-b-md'>{t("discountUpTo")}{item.offers.filter(ele => ele.percentage > 1).sort((a, b) => a.percentage > b.percentage)[0].percentage} %</div> : ""}
                                        {(()=>{
                                            if( shippingOffers.find(d=>d.id==item.id) &&shippingOffers.find(d=>d.id==item.id).offers.length > 0&& shippingOffers.find(d=>d.id==item.id).offers.filter(ele => ele.percentage > 1).sort((a, b) => a.percentage > b.percentage).length > 0){
                                            let percentage=shippingOffers.find(d=>d.id==item.id).offers.filter(ele => ele.percentage > 1).sort((a, b) => a.percentage > b.percentage)[0].percentage
                                            let offer=shippingOffers.find(d=>d.id==item.id).offers.filter(ele => ele.percentage > 1).sort((a, b) => a.percentage > b.percentage)[0]
                                            if(percentage==100){
                                                return <div className='p-1 bg-[#bbe0e1] text-black  font-bold  rounded-b-md ' style={{margin:"0px 10px"}}> {t("freeDelivery")} </div>
                                            }
                                            else{
                                                let amountDiscount=offer.amountDiscount
                                                return <div className=' p-1 bg-[#bbe0e1] text-black font-bold rounded-b-md m-2:md m-0' style={{margin:"0px 10px"}}>{t("discountDeliveryUpTo")} {percentage} % {amountDiscount>0?amountDiscount:""}</div>
                                            }
                                            }
                                        })()}
                                       
                                          
                                            </div>

                                        {
                                            item.sponsor == true ?


                                                <div className={style.yellowsquare}>
                                                    <p style={{ marginBottom: 0 }}>{t("advertiser")}</p>
                                                </div>
                                                : ""
                                        }
                                        {/* {item.entityType[0].code != "merchant" ?
                                            item.rating.length ?
                                                item.rating.map(rate => {
                                                    return (
                                                        <div className={style.yellowsquare2 + " left-11"} >
                                                            <p style={{ marginBottom: 0 }}>{(rate.ratingDegree.toFixed(2))}</p>
                                                        </div>
                                                    )
                                                })
                                                : ""
                                            : ""
                                        } */}
                                        <div className='w-full h-full'>
                                        <div className={" absolute right-2 md:right-16 z-10"}>
                                        <span className={style.WordSpace + " block min-w-[7rem]  w-full " + style.ET}>

                                                    {item.entityType[0].code == "merchant" ?
                                                        item.entityCategories.length > 0 && item.entityCategories[0].entityCategories.length > 0 && item.entityCategories[0].entityCategories.filter(ele => ele.language.code == locale)[0].name :
                                                        item.entityType.filter(
                                                            c =>
                                                                c.language.code == router.locale
                                                        ).length > 0
                                                            ? item.entityType.filter(
                                                                c =>
                                                                    c.language.code ==
                                                                    router.locale
                                                            )[0].name
                                                            : ""
                                                    }
                                                </span></div>
                                            <div className={ " h-full"}>
                                            <div className={" flex flex-row py-4 px-2 h-full"}>
                                                <div className='flex items-center  w-full'>               
                                                             <div className=''>
                                                    <Stack direction="row" spacing={1} className={style.Stack}>
                                                        {(() => {
                                                            let pathname = ''
                                                            if (item.entityType[0].code == "merchant") {
                                                                if (item.entityCategories.length > 0 && item.entityCategories[0].entityCategories.length > 0) {
                                                                    pathname = (`${constants.HakeemMedical}/${item.entityCategories[0].entityCategories[0].code}/${item.slug && item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                                }
                                                                else {
                                                                    pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                                }
                                                            }
                                                            else if (JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == item.entityType[0].code).length > 0) {
                                                                pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                            }
                                                            else {
                                                                pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                            }
                                                
                                                            return <Link
                                                                className={style.AtagIcon}
                                                                href={pathname}
                                                       
                                                            >
                                                                {
                                                                    item.entityImages.length > 0 &&
                                                                        item.entityImages.filter(r => r.image != null).length > 0 ?
                                                                        <Avatar
                                                                            alt={
                                                                                item.transEntityDetails[0].officialName.length > 30 ?
                                                                                    item.transEntityDetails[0].officialName.substr(0, 30) + "... "
                                                                                    :
                                                                                    item.transEntityDetails[0].officialName
                                                                            } src={`${item.entityImages.filter(r => r.image != '' && r.image != null)[0].image}`}
                                                                            className={style.sizeAvatar + " " + style.Cursor + " " + style.borderAvatar}

                                                                        />
                                                                        :
                                                                        <Avatar
                                                                            alt={
                                                                                item.transEntityDetails[0].officialName.length > 30 ?
                                                                                    item.transEntityDetails[0].officialName.substr(0, 30) + "... "
                                                                                    :
                                                                                    item.transEntityDetails[0].officialName
                                                                            } src={`${config.basePath}/assest/logo.svg`}
                                                                            className={style.sizeAvatar + " " + style.Cursor + " " + style.borderAvatar}

                                                                        />
                                                                }
                                                            </Link>
                                                        })()}
                                                    
                                                    </Stack>
                                                    <BootstrapDialog
                                                        onClose={handleClose}
                                                        aria-labelledby="customized-dialog-title"
                                                        open={open == item.id}
                                                    >
                                                        <DialogContent dividers>
                                                            <Stack
                                                                direction="row"
                                                                spacing={1}
                                                                className={style.Stack}
                                                            >
                                                                <div className={style.avater}>
                                                                    {


                                                                        item.entityImages.length > 0 &&
                                                                            item.entityImages.filter(r => r.image != null).length > 0 ?
                                                                            <img alt={
                                                                                item.transEntityDetails[0].officialName.length > 30 ?
                                                                                    item.transEntityDetails[0].officialName.substr(0, 30) + "... "
                                                                                    :
                                                                                    item.transEntityDetails[0].officialName
                                                                            }
                                                                                src={`${item.entityImages.filter(r => r.image != '' && r.image != null)[0].image}`}
                                                                                className={style.sizeAvatarWithoutborder}

                                                                            />
                                                                            :
                                                                            <img
                                                                                alt={
                                                                                    item.transEntityDetails[0].officialName.length > 30 ?
                                                                                        item.transEntityDetails[0].officialName.substr(0, 30) + "... "
                                                                                        :
                                                                                        item.transEntityDetails[0].officialName
                                                                                } src={`${config.basePath}/assest/logo.svg`}
                                                                                className={style.sizeAvatarWithoutborder}

                                                                            />
                                                                    }
                                                                </div>
                                                            </Stack>
                                                        </DialogContent>
                                                    </BootstrapDialog>
                                                </div>
                                            
                                             
                                                       

                                   
                                                        {
                                                            item.fieldConfig && showslider ?
                                                                lstMedicalDataWorkTimes.length > 0 && lstMedicalDataWorkTimes.filter(ele => ele.id == item.id).length > 0 ?
                                                                    lstMedicalDataWorkTimes.filter(ele => ele.id == item.id).some(timeItem => timeItem.id == item.id) ?
                                                                        isOpenOrClose(lstMedicalDataWorkTimes.filter(ele => ele.id == item.id).find(timeItem => timeItem.id == item.id).entityWorkDays.filter(workDay => workDay.dayId !== null)) ?
                                                                            <div className={style.Open + " " + style.borderradiusTopMedical}>
                                                                                <p style={{ marginBottom: 0 }}>{t("Open")}</p>
                                                                            </div>
                                                                            :
                                                                            <div className={style.Close + " " + style.borderradiusTopMedical}>
                                                                                <p style={{ marginBottom: 0 }}>{t("Close")}</p>
                                                                            </div>
                                                                        :
                                                                        ""
                                                                    :
                                                                    ""
                                                                :
                                                                ""
                                                        }
                                                
                                                <div className={style.positiontext+" w-10/12 px-2 text-right mt-12 md:mt-0"}>
                                                        {(() => {
                                                            let pathname = ''
                                                            if (item.entityType[0].code == "merchant") {
                                                                if (item.entityCategories.length > 0 && item.entityCategories[0].entityCategories.length > 0) {

                                                                    pathname = (`${constants.HakeemMedical}/${item.entityCategories[0].entityCategories[0].code}/${item.slug && item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')

                                                                }
                                                                else {

                                                                    pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug && item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                                }
                                                            }
                                                            else if (JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == item.entityType[0].code).length > 0) {
                                                                pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug && item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                            }
                                                            else {
                                                                pathname = (`${constants.HakeemMedical}/${item.entityType[0].code}/${item.slug && item.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? item.slug.filter(i => i.active == true)[0].url : item.id}`).replace('/[^a-zA-Z0-9-_]/g', '')
                                                            }
                                                            return <Link
                                                                className={style.AtagIcon}
                                                                href={pathname}
                                                                
                                                                passHref
                                                          
                                                            >
                                                                <span className={style.AtagIcon + " " + style.hoverLink}
                                                                    onClick={(e) => handleAddSponsor(e, item)}
                                                                >
                                                                    <p className={style.textaboutdoctor2 + " " + style.Blod + " " + style.WordSpace}>
                                                                        {
                                                                            item.transEntityDetails[0].officialName.length > 200 ?
                                                                                item.transEntityDetails[0].officialName.substr(0, 200) + "... "
                                                                                :
                                                                                item.transEntityDetails[0].officialName
                                                                        }
                                                                    </p></span></Link>
                                                        })()}
                                                
                                                <div className='flex gap-2 pt-2'>
                                                        {JSON.parse(config.env.hakeemBookOnEntityTypesCodes).filter(x => x == item.entityType[0].code).length > 0 ?
                                                               <p className={style.textaboutdoctor2 + " w-full " + style.paddingtopmedicaltext}>
                                                               {router.query.major != null && lstMedicalDataMajors && lstMedicalDataMajors.length > 0 &&
                                                                 lstMedicalDataMajors.filter(
                                                                   majorItem =>
                                                                     majorItem.entityDetailsId == item.id &&
                                                                     majorItem.major &&
                                                                     majorItem.major.length > 0 &&
                                                                     majorItem.major.filter(i => i.name == router.query.major).length > 0
                                                                 ).length > 0 ? (
                                                                   <span>
                                                                     {
                                                                       lstMedicalDataMajors.filter(
                                                                         majorItem =>
                                                                           majorItem.entityDetailsId == item.id &&
                                                                           majorItem.major &&
                                                                           majorItem.major.length > 0 &&
                                                                           majorItem.major.filter(i => i.name == router.query.major).length > 0
                                                                       )[0].major[0].name
                                                                     }
                                                                   </span>) :
                                                                 lstMedicalDataMajors.length > 0 && lstMedicalDataMajors.filter(ele => ele.entityDetailsId == item.id).length > 0 &&
                                                                   lstMedicalDataMajors.filter(ele => ele.entityDetailsId == item.id).some(majorItem => majorItem.entityDetailsId == item.id) ?
                                                                   <>
                                                                     <span>{
                                                                       lstMedicalDataMajors.filter(ele => ele.entityDetailsId == item.id).filter(majorItem => majorItem.entityDetailsId == item.id).sort((a, b) => (b.priority - a.priority))[0].major.length > 0 ? lstMedicalDataMajors.filter(ele => ele.entityDetailsId == item.id).filter(majorItem => majorItem.entityDetailsId == item.id).sort((a, b) => (b.priority - a.priority))[0].major[0].name : ""
                                                                     }</span>
                                                                   </>
                                                                   :
                                                                   ""
                                                               }
                                                             </p>
                                                            :
                                                            <p className={style.textaboutdoctor2 + " " + style.paddingtopmedicaltext}>
                                                              
                                                                {JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == item.entityType[0].code).length > 0 && item.addressDetails
                                                                    ? item.addressDetails.map(i => {
                                                                    
                                                                        let cityAddress =
                                                                            i.city &&
                                                                                i.city.filter(
                                                                                    c =>
                                                                                        c.language.code == router.locale
                                                                                ).length > 0
                                                                                ? i.city.filter(
                                                                                    c =>
                                                                                        c.language.code ==
                                                                                        router.locale
                                                                                )[0].name
                                                                                : "";
                                                                        let countryAddress =
                                                                            i.country &&
                                                                                i.country.filter(
                                                                                    c =>
                                                                                        c.language.code == router.locale
                                                                                ).length > 0
                                                                                ? i.country.filter(
                                                                                    c =>
                                                                                        c.language.code ==
                                                                                        router.locale
                                                                                )[0].name
                                                                                : "";
                                                                        let districtAddress =
                                                                            i.district &&
                                                                                i.district.filter(
                                                                                    c =>
                                                                                        c.language.code == router.locale
                                                                                ).length > 0
                                                                                ? i.district.filter(
                                                                                    c =>
                                                                                        c.language.code ==
                                                                                        router.locale
                                                                                )[0].name
                                                                                : "";
                                                                       
                                                                        return (
                                                                            <div className={ "flex " + style.paddingtopmedicaltext2}>
                                                                            <div><LocationOnIcon
                                                                                sx={{ color: "#008C8D " }}
                                                                            /></div>
                                                                                <div className={style.textaboutdoctor3}>{countryAddress +
                                                                                    " - " +
                                                                                    cityAddress +
                                                                                    " - " +
                                                                                    districtAddress

                                                                                }</div>
                                                                            </div>
                                                                        );
                                                                       
                                                                    })
                                                                    : ""}
                                                            </p>
                                                        }
                                                       <div className={style.profileMedical+" flex  items-center justify-center"}>
                      { item.entityType[0].code != "merchant" ? 
                      item.rating.length ?
                        item.rating.map(rate => {
                          return (
                            <div className={" relative w-12 bg-[#faaf00] text-center text-white"} >
                              <p style={{ marginBottom: 0 }}>{(rate.ratingDegree.toFixed(2))}</p>
                            </div>

                          )
                        })
                        : ""
                        :""
                    }
                                                        </div>
                                                        {item.entityType[0].code != "merchant" ?  <div className={ "flex gap-2 " }>
                              <div className={style.iconandtext}>
                                <p className={style.icontext}>                                        {
                                  item.rating.length ?
                                    item.rating.map(rate => {
                                      return (rate.ratingCount)
                                    })
                                    : ""
                                }</p>
                                {item.rating&&item.rating.length ?<PersonOutlineOutlinedIcon className={style.iconsSize + " " + style.TealColor} />:""}
                              </div>
                            </div>:""}
                            </div>
                            <div className={"flex " + " " + style.paddingtopmedicaltext2}>
                              <div><LocalPhoneOutlineIcon className={style.TealColor} />
                              </div>
                              <p className={style.textaboutdoctor3}>{JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == item.entityType[0].code).length > 0 ?constants.MobileDite:constants.MobileMed}</p>
                            </div>
                            <div className={style.positionStarMedical +" justify-start"}>

                            {item.entityType[0].code != "merchant" ?   
                            <Rating name="simple-controlled" value={
                                Math.floor((item.rating.length > 0 ?
                                  item.rating.map(rate => {
                                    return (rate.ratingDegree.toFixed(2))
                                  })
                                  : [0.00])[0])
                              }
                                className={style.sizestars}
                                onChange={(event, newValue) => {
                                  setValue(newValue)
                                }} readOnly />:""}
                                                  </div>
                            
                            </div>
                            </div>
                        
                      
                        </div>
                        </div>
                        </div>
                      {/* </div> */}
                    </div></span>
                </div>       
                                       
                        )
                    })
                }
                <div style={{textAlign: "center",display:"flex",justifyContent:"center" }} className='flex w-full justify-center'>
                    {" "}
                    {loading ? <Loading /> : ""}
                </div>
            </div>
            {lstMedicalData && lstMedicalData.length > 0 && showSeeMore && props.isInSearchPage ? <div className={style.textaboutdoctor1 + " " + style.Blod}>
                <SeeMore getMore={getMore} loading={loading} /></div> : ""}
            {lstMedicalData.length == 0 && loading == false ? <NoData /> : ""}
        </>

    )
}

export default NearestEntities
